import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import setter from '@/lib/setter';
import { queryDocTodo, queryIsDelayDocument, withdrawOption } from '@/api/notice/documentApi.js';
export default {
  data: function data() {
    var _this = this;
    return {
      form: {
        fileName: undefined,
        createTime: []
      },
      columns: [{
        title: '公文类型',
        dataIndex: 'docType',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'docType'
        }
      }, {
        title: '公文编号',
        dataIndex: 'fileCode',
        align: 'center',
        ellipsis: true,
        width: 100
      }, {
        title: '公文名称',
        dataIndex: 'fileName',
        align: 'center',
        ellipsis: true,
        width: 150
      }, {
        title: '拟稿日期',
        dataIndex: 'createTime',
        align: 'center',
        width: 150
      }, {
        title: '拟稿人',
        dataIndex: 'drafterTemp',
        align: 'center',
        width: 180,
        scopedSlots: {
          customRender: 'drafterTemp'
        }
      }, {
        title: '当前环节',
        scopedSlots: {
          customRender: 'nowStep'
        },
        align: 'center',
        width: 100
      }, {
        title: '审核状态',
        dataIndex: 'auditStatus',
        align: 'center',
        scopedSlots: {
          customRender: 'auditStatus'
        },
        width: 100
      }, {
        title: '审核日期',
        dataIndex: 'auditDate',
        align: 'center',
        width: 150
      }, {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      tableData: [],
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 19
      },
      paginationTable: {
        total: 0,
        defaultPageSize: 10,
        showTotal: function showTotal(total) {
          return "\u5171 ".concat(total, " \u6761\u6570\u636E");
        },
        showSizeChanger: true,
        pageSizeOptions: ['10', '15', '20'],
        onShowSizeChange: function onShowSizeChange(current, pageSize) {
          return _this.pageSize = pageSize;
        }
      }
    };
  },
  methods: {
    loadData: function loadData() {
      var _this2 = this;
      var req = {
        queryStr: this.form.fileName,
        startDate: this.form.createTime.length > 0 ? this.form.createTime[0] + ' 00:00:00' : '',
        endDate: this.form.createTime.length > 0 ? this.form.createTime[1] + ' 23:59:59' : '',
        currentNo: this.paginationTable.current,
        pageSize: this.paginationTable.pageSize
      };
      queryDocTodo(req).then(function (res) {
        if (res.data.code == 200) {
          _this2.tableData = res.data.data.rows;
          _this2.paginationTable.total = res.data.data.total;
        }
      });
    },
    onShowSizeChange: function onShowSizeChange(current, pageSize) {
      this.paginationTable.current = 1;
      this.paginationTable.pageSize = pageSize;
      this.loadData();
    },
    pageChange: function pageChange(page, pageSize) {
      this.paginationTable.current = page;
      this.paginationTable.pageSize = pageSize;
      this.loadData();
    },
    handleSubmit: function handleSubmit() {
      this.paginationTable.current = 1;
      this.paginationTable.pageSize = 10;
      this.loadData();
    },
    firstTrial: function firstTrial(row) {
      var req = {
        id: row.docId,
        auditId: row.id,
        docStatus: row.docStatus
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          mode: 'firstTrial',
          data: req
        }
      });
    },
    groupSign: function groupSign(row) {
      var req = {
        id: row.docId,
        auditId: row.id,
        docStatus: row.docStatus
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          mode: 'groupSign',
          data: req
        }
      });
    },
    reCheck: function reCheck(row) {
      var req = {
        id: row.docId,
        auditId: row.id,
        docStatus: row.docStatus
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          mode: 'reCheck',
          data: req
        }
      });
    },
    signIssue: function signIssue(row) {
      var req = {
        id: row.docId,
        auditId: row.id,
        docStatus: row.docStatus
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          mode: 'signIssue',
          data: req
        }
      });
    },
    proofread: function proofread(row) {
      var req = {
        id: row.docId,
        auditId: row.id,
        docStatus: row.docStatus
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          mode: 'proofread',
          data: req
        }
      });
    },
    reView: function reView(row) {
      var req = {
        id: row.docId,
        auditId: row.id,
        isEmergent: row.isEmergent,
        tempId: row.tempId,
        docStatus: row.docStatus,
        auditStep: row.auditStep
      };
      localStorage.removeItem('needData');
      localStorage.setItem('needData', JSON.stringify(req));
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          mode: 'reView',
          data: req
        }
      });
    },
    viewClick: function viewClick(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, req;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return queryIsDelayDocument({
                docId: row.docId
              });
            case 1:
              res = _context.v;
              if (!(res.data.data === 1)) {
                _context.n = 2;
                break;
              }
              _this3.$message.error('此公文审核未通过，无法进行查看！');
              return _context.a(2);
            case 2:
              req = {
                id: row.docId,
                auditId: row.id,
                tempId: row.tempId,
                docStatus: row.docStatus
              };
              localStorage.removeItem('needData');
              localStorage.setItem('needData', JSON.stringify(req));
              _this3.$router.push({
                path: '/docNotice/doc/docSendView',
                query: {
                  data: req,
                  backto: 'deal'
                }
              });
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    printClick: function printClick(row) {
      var req = {
        id: row.docId,
        auditId: row.id,
        tempId: row.tempId,
        docStatus: row.docStatus
      };
      this.$router.push({
        path: '/docNotice/doc/docReview',
        query: {
          data: req,
          mode: 'print'
        }
      });
    },
    handleWithdrawOption: function handleWithdrawOption(row) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var userInfo, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              userInfo = JSON.parse(localStorage.getItem('hyd-userInfo'));
              _context2.n = 1;
              return withdrawOption({
                userId: userInfo.userId,
                id: row.id,
                docId: row.docId,
                docData: row.docData
              });
            case 1:
              res = _context2.v;
              if (res.data.code == 200) {
                _this4.$message.success('公文撤回成功！');
                _this4.loadData();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  },
  mounted: function mounted() {
    this.loadData();
  }
};